namespace TabAurous.Purchase {
    export namespace ApprovalInReturnService {
        export const baseUrl = 'Purchase/ApprovalInReturn';

        export declare function Create(request: Serenity.SaveRequest<ApprovalInReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ApprovalInReturnRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ApprovalInReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function PartyList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<ApprovalInReturnRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Purchase/ApprovalInReturn/Create",
            Update = "Purchase/ApprovalInReturn/Update",
            Delete = "Purchase/ApprovalInReturn/Delete",
            Retrieve = "Purchase/ApprovalInReturn/Retrieve",
            List = "Purchase/ApprovalInReturn/List",
            PartyList = "Purchase/ApprovalInReturn/PartyList"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'PartyList'
        ].forEach(x => {
            (<any>ApprovalInReturnService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
